var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWineGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 464H184.006V348.5C256.647 336 310.283 269.75 303.406 192.625L287.53 14.5C286.778 6.25 279.903 0 271.776 0H48.225C40.098 0 33.223 6.25 32.471 14.5L16.594 192.625C9.717 269.75 63.354 336 135.994 348.5V464H72C58.75 464 48 474.75 48 488S58.75 512 72 512H248C261.25 512 272 501.25 272 488S261.25 464 248 464ZM242.268 48L249.451 128H70.549L77.733 48H242.268ZM64.354 197L66.239 176H253.762L255.647 197C260.643 253.547 217.801 304 160 304C102.137 304 59.358 253.533 64.354 197Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineGlass);
export default __webpack_public_path__ + "static/media/wine-glass.be54cc357fc50a37350ac37e892414aa.svg";
export { ForwardRef as ReactComponent };